<template>
  <div>

    <div>
      <table>
        <tr>
          <td colspan="7"><b>Lease rates 1</b></td>
        </tr>
        <tr>
          <td>Quarterly payments</td>
          <td>4</td>
          <td>8</td>
          <td>12</td>
          <td>16</td>
          <td>20</td>
          <td>24</td>
        </tr>
        <tr>
          <td>Months</td>
          <td>12</td>
          <td>24</td>
          <td>36</td>
          <td>48</td>
          <td>60</td>
          <td>72</td>
        </tr>
        <tr>
          <td>Years</td>
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>4</td>
          <td>5</td>
          <td>6</td>
        </tr>
        <tr>
          <td>Lease rate</td>
          <td v-for="rate in rates1">{{ rate }}</td>
        </tr>

        <tr>
          <td colspan="7"><b>Lease rates 2</b></td>
        </tr>
        <tr>
          <td>Quarterly payments</td>
          <td>4</td>
          <td>8</td>
          <td>12</td>
          <td>16</td>
          <td>20</td>
          <td>24</td>
        </tr>
        <tr>
          <td>Months</td>
          <td>12</td>
          <td>24</td>
          <td>36</td>
          <td>48</td>
          <td>60</td>
          <td>72</td>
        </tr>
        <tr>
          <td>Years</td>
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>4</td>
          <td>5</td>
          <td>6</td>
        </tr>
        <tr>
          <td>Lease rate</td>
          <td v-for="rate in rates2">{{ rate }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'lease-rates',
    data() {
      return {
        rates1: [
          0.277,
          0.145,
          0.101,
          0.079,
          0.06555,
          0.05691,
        ],
        rates2: [
          0.28731,
          0.15214,
          0.107,
          0.08502,
          0.07179,
          0.06306,
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Debug/QuoteInfo/LeaseRates.vue